import { AffiliateStatisticDateFilterInterface } from 'modules/affiliate/types/affiliate-statistic-interface'
import { getMonthDateRange } from 'shared/utils/get-dates'

export const isDefaultFilter = (
  filter: AffiliateStatisticDateFilterInterface,
  timeZone?: string,
) => {
  const [dateSince, dateTill] = getMonthDateRange(timeZone)
  return filter.dateSince === dateSince && filter.dateTill === dateTill
}
